import React, { useEffect, useState } from 'react';
import { Sparkles, Send, ArrowRight, ChevronDown } from 'lucide-react';
import { motion } from 'framer-motion';
const SUGGESTIONS = ['Retirees in Florida with $2M+ in investable assets...', 'Tech executives in the Bay Area with $5M+ net worth...', 'Small business owners in Texas with 50+ employees...', 'Healthcare professionals under 40 with high income growth...'];
export function HeroChatbox({
  onSubmit
}: {
  onSubmit?: (prompt: string) => void;
}) {
  const [currentSuggestionIndex, setCurrentSuggestionIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const [inputValue, setInputValue] = useState('');
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    const currentText = SUGGESTIONS[currentSuggestionIndex];
    if (isTyping) {
      if (displayText.length < currentText.length) {
        timeout = setTimeout(() => {
          setDisplayText(currentText.slice(0, displayText.length + 1));
        }, 50);
      } else {
        timeout = setTimeout(() => {
          setIsTyping(false);
        }, 2000);
      }
    } else {
      if (displayText.length > 0) {
        timeout = setTimeout(() => {
          setDisplayText(displayText.slice(0, -1));
        }, 20);
      } else {
        setCurrentSuggestionIndex(prev => (prev + 1) % SUGGESTIONS.length);
        setIsTyping(true);
      }
    }
    return () => clearTimeout(timeout);
  }, [displayText, isTyping, currentSuggestionIndex]);
  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(inputValue.trim() || SUGGESTIONS[currentSuggestionIndex].replace('...', ''));
    }
  };
  return <div className="w-full max-w-3xl mx-auto pt-16 pb-12 px-4 flex flex-col items-center text-center" data-id="element-327">
      <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-6" data-id="element-328">
        <Sparkles className="text-teal-500" size={24} data-id="element-329" />
      </div>

      <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-330">
        What kind of customers do you want to target?
      </h2>
      <p className="text-gray-600 text-lg mb-8" data-id="element-331">
        Tell us in plain language - I'll turn it into a Market Lens.
      </p>

      <div className="w-full bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6 text-left" data-id="element-332">
        <div className="flex items-center text-teal-600 font-medium mb-4 text-sm" data-id="element-333">
          <Sparkles size={16} className="mr-2" data-id="element-334" />
          Ask Copilot
        </div>

        <div className="relative rounded-xl p-[2px] overflow-hidden group" data-id="element-335">
          <div className="absolute inset-0 bg-[conic-gradient(from_0deg,transparent_0_340deg,#0D9488_360deg)] animate-spin-slow opacity-50" data-id="element-336"></div>
          <div className="absolute inset-0 bg-[conic-gradient(from_180deg,transparent_0_340deg,#3B82F6_360deg)] animate-spin-slow opacity-50" data-id="element-337"></div>

          <div className="relative bg-white rounded-[10px] flex items-center px-4 py-3 border border-gray-200 group-hover:border-transparent transition-colors" data-id="element-338">
            <span className="text-gray-400 mr-1" data-id="element-339">e.g. "</span>
            <div className="flex-1 relative h-6 flex items-center" data-id="element-340">
              {!inputValue && <span className="text-gray-500 absolute left-0 truncate w-full pointer-events-none" data-id="element-341">
                  {displayText}
                  <motion.span animate={{
                opacity: [1, 0]
              }} transition={{
                repeat: Infinity,
                duration: 0.8
              }} className="inline-block w-[2px] h-4 bg-teal-500 ml-[1px] align-middle" data-id="element-342" />
                </span>}
              <input type="text" value={inputValue} onChange={e => setInputValue(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleSubmit()} className="w-full h-full bg-transparent outline-none text-gray-900 z-10 relative" placeholder="" data-id="element-343" />
            </div>
            <span className="text-gray-400 ml-1" data-id="element-344">"</span>

            <button onClick={handleSubmit} className="ml-3 p-2 text-gray-400 hover:text-teal-600 hover:bg-teal-50 rounded-lg transition-colors" data-id="element-345">
              <Send size={18} className="transform rotate-45" data-id="element-346" />
            </button>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-6 text-sm font-medium" data-id="element-347">
        <button className="text-teal-600 hover:text-teal-700 flex items-center transition-colors" data-id="element-348">
          Get help creating market lens{' '}
          <ArrowRight size={16} className="ml-1" data-id="element-349" />
        </button>
        <button className="text-teal-600 hover:text-teal-700 flex items-center transition-colors" data-id="element-350">
          Analyze my market opportunities{' '}
          <ArrowRight size={16} className="ml-1" data-id="element-351" />
        </button>
        <button className="text-gray-500 hover:text-gray-700 flex items-center transition-colors" data-id="element-352">
          More <ChevronDown size={16} className="ml-1" data-id="element-353" />
        </button>
      </div>
    </div>;
}